// extracted by mini-css-extract-plugin
export default {"release_license_info":"ReleaseLicenseInfo_release_license_info__MU5OI","release_license_text":"ReleaseLicenseInfo_release_license_text__ExaeI"};